const listContracts = ['TEFAFContracts'];

export { listContracts };
